export function dedupByAggregateId<T extends { aggregateId: string }>(items: T[]): T[] {
	const seen = new Set<string>();
	const out: T[] = [];
	for (const item of items) {
		if (seen.has(item.aggregateId)) {
			continue;
		}
		seen.add(item.aggregateId);
		out.push(item);
	}
	return out;
}
